import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
import Container from '@material-ui/core/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
//import MenuItem from '@material-ui/core/MenuItem';
//import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@mui/material/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner'
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment/moment";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function AddReseller(props){
    const classes = useStyles();
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [description, setDescription] = useState("");
    //const [superReseller, setSuperReseller] = useState(0);
    //const [superResellersList, setSuperResellersList] = useState([]);
    const paperStyle = {padding: 20};

    useEffect(() => {
        console.log('inside add reseller');
        props.onInitializeAddReseller();
    }, []);

    useEffect(() => {
        if (props.isErrorAddReseller){
            var errorMessage = '' + props.isErrorAddReseller;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorAddReseller]);

    //useEffect(() => {
    //    if (props.superResellers && props.superResellers.length){
    //        setSuperResellersList(props.superResellers);
    //    }
    //},[]);

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    function validateForm() {
        return login.length > 0 && password.length > 0;
    }

    function handleSubmit(event) {
        event.preventDefault();
        console.log("login", login);
        console.log("password", password);

        const data = {
            login: login,
            password: password,
            description: description
        };
        console.log('data', data);
        //if (superReseller === 0){
        //    var errorMessage = 'Please select a super reseller';
        //    props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        //} else {
        props.onAddReseller(props.token, data);
        //}
        //props.onAddReseller(props.token, data);
    }

    let addResellerRedirect = null;
    if(props.isSuccessAddReseller){
        var successMessage = 'Added ' + props.isSuccessAddReseller.name;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});

        addResellerRedirect = <Redirect to="/resellers" />
    }

    // let displayError = null;
    // if (props.isErrorAddReseller){
    //     //displayError = <Alert variant="danger">{props.isErrorAddReseller}</Alert>
    //     var errorMessage = '' + props.isErrorAddReseller;
    //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
    // }
    // <InputLabel id="select-super-label">Select Super Reseller</InputLabel>

    return (
        <div>
            {addResellerRedirect}
            <Container maxWidth="xs">
                <Paper elevation={10} style={paperStyle}>
                    <Grid align="center">
                        <Typography sx={{mb: 3.5, fontSize: 20}} component="div">
                            Add Reseller
                        </Typography>
                    </Grid>
                    <form onSubmit={handleSubmit}>
                        <Grid container direction={"column"} spacing={3}>
                            <Grid item>
                                <TextField
                                    autoFocus
                                    id="login"
                                    type="text"
                                    value={login}
                                    label="Enter login name"
                                    onChange={e => setLogin(e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    id="password"
                                    value={password}
                                    label="Enter password"
                                    onChange={e => setPassword(e.target.value)}
                                    type="text"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    id="description"
                                    value={description}
                                    label="Description"
                                    onChange={e => setDescription(e.target.value)}
                                    type="text"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    block
                                    disabled={!validateForm() || props.isLoadingAddReseller}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                >
                                    {props.isLoadingAddReseller
                                        ? spinner
                                        : 'Add'}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
            </Container>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onInitializeAddReseller: () => dispatch(actions.initializeAddReseller()),
        onAddReseller: (token, data) => dispatch(actions.addReseller(token, data)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        isLoadingAddReseller: state.addReseller.loading,
        isErrorAddReseller: state.addReseller.error,
        isSuccessAddReseller: state.addReseller.reseller,
        //superResellers: state.superResellers.super_reseller_list

    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AddReseller);